// export const localhost = 'http://185.69.153.95:1335';
export const localhost = 'http://185.69.153.95:1337';